import React, { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../../styles/OfficeProcedures.css";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export default function BCOfficeProcedures({ setProvince }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const [expandedAccordion, setExpandedAccordion] = useState(false);
  const [Board, setBoard] = useState("");

  const handleBoardChange = (e) => {
    setBoard(e.target.value);
  };

  // Add CSS for accordion content
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .accordion-content ol {
        margin-left: -15px !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    setProvince("BC");
  });

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);

    // Scroll to the top of the first accordion when expanded (mobile only)
    if (isExpanded && window.innerWidth <= 768) {
      console.log(
        "Accordion clicked, panel:",
        panel,
        "isExpanded:",
        isExpanded,
      );

      // Use a longer timeout for iOS and add multiple attempts
      const scrollToFirstAccordion = () => {
        // Try multiple selectors to find the first accordion
        const firstAccordion =
          document.querySelector('[data-testid="accordion-0"]') ||
          document.querySelector(".MuiAccordion-root") ||
          document.querySelector('[role="region"]');
        console.log("Found first accordion:", firstAccordion);

        if (firstAccordion) {
          console.log("Attempting to scroll to first accordion");
          try {
            // Get the position and add offset to position just below header
            const rect = firstAccordion.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = scrollTop + rect.top - 80; // 80px offset to position below header

            console.log("Current scroll position:", scrollTop);
            console.log("Accordion rect.top:", rect.top);
            console.log("Target position:", targetPosition);

            // Use requestAnimationFrame for smoother scrolling on iOS
            requestAnimationFrame(() => {
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
              });
            });
          } catch (error) {
            console.error("Error scrolling to first accordion:", error);
          }
        } else {
          console.log("No first accordion found, trying fallback");
          // Fallback: try to scroll to the transaction topic container
          const transactionContainer = document.querySelector(".max-w-5xl");
          if (transactionContainer) {
            console.log("Using fallback container");
            const rect = transactionContainer.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = scrollTop + rect.top - 80;

            requestAnimationFrame(() => {
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
              });
            });
          }
        }
      };

      // First attempt after a longer delay for iOS
      setTimeout(scrollToFirstAccordion, 100);

      // Second attempt after a longer delay for slower devices
      setTimeout(scrollToFirstAccordion, 300);

      // Third attempt after an even longer delay for very slow devices
      setTimeout(scrollToFirstAccordion, 500);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="body pt-10">
        <div className="max-w-5xl w-full flex justify-left mt-5">
          <div className="mt-2 mb-1 max-w-5xl w-full">
            <Accordion
              expanded={expandedAccordion === "panel1"}
              onChange={handleAccordionChange("panel1")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Deposit Instructions
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <p>
                  Please complete the form, as linked below, for all deals so
                  that you are sending the most up to date deposit delivery
                  instructions to the Buyer. For any deposit issues please
                  connect with the Deposits Team:{" "}
                  <a href="mailto:bcdeposits@exprealty.net">
                    bcdeposits@exprealty.net
                  </a>{" "}
                  or 1-833-497-4422.
                  <br />
                  <br />
                  <a
                    href="https://exprealty.formstack.com/forms/bc_deposit"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Deposit Instructions Form
                  </a>
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel10"}
              onChange={handleAccordionChange("panel10")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel10-content"
                id="panel10-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Managing Broker Signature Emails - By Board
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <ThemeProvider theme={theme}>
                  <FormControl
                    sx={{ ml: 1, mt: 1, mb: 2, minWidth: 325, maxWidth: 110 }}
                  >
                    <InputLabel size="small" className="select-default-label">
                      Select Your Real Estate Board
                    </InputLabel>
                    <Select
                      value={Board}
                      name="Select Your Real Estate Board"
                      label="Select Your Real Estate Board"
                      onChange={handleBoardChange}
                      size="small"
                      sx={{ borderRadius: 20 }}
                      defaultValue="Select Your Real Estate Board"
                    >
                      <MenuItem key={Math.random()} value="AIR">
                        AIR
                      </MenuItem>
                      <MenuItem key={Math.random()} value="BCNREB">
                        BCNREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="CADREB">
                        CADREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="FVREB">
                        FVREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="GVR">
                        GVR (Previously REBGV)
                      </MenuItem>
                      <MenuItem key={Math.random()} value="PRSCREB">
                        PRSCREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="VIREB">
                        VIREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="VREB">
                        VREB
                      </MenuItem>
                    </Select>
                  </FormControl>
                </ThemeProvider>
                <p>
                  {Board === "AIR" ? (
                    <>
                      <b>AIR: </b>
                      <a href="mailto:airmbsignatures@exprealty.net">
                        airmbsignatures@exprealty.net
                      </a>{" "}
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "BCNREB" ? (
                    <>
                      <b>BCNREB: </b>
                      <a href="mailto:bcnrebmbsignatures@exprealty.net">
                        bcnrebmbsignatures@exprealty.net
                      </a>
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "CADREB" ? (
                    <>
                      <b>CADREB: </b>
                      <a href="mailto:cadrebmbsignatures@exprealty.net">
                        cadrebmbsignatures@exprealty.net
                      </a>
                      <br />
                    </>
                  ) : (
                    ""
                  )}

                  {Board === "FVREB" ? (
                    <>
                      <b>FVREB: </b>
                      <a href="mailto:fvrebmbsignatures@exprealty.net">
                        fvrebmbsignatures@exprealty.net
                      </a>
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "GVR" ? (
                    <>
                      <b>GVR: </b>
                      <a href="mailto:rebgvmbsignatures@exprealty.net">
                        rebgvmbsignatures@exprealty.net
                      </a>
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "PRSCREB" ? (
                    <>
                      <b>PRSCREB: </b>
                      <a href="mailto:prscrebmbsignatures@exprealty.net">
                        prscrebmbsignatures@exprealty.net
                      </a>
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "VIREB" ? (
                    <>
                      <b>VIREB: </b>
                      <a href="mailto:virebmbsignatures@exprealty.net">
                        virebmbsignatures@exprealty.net
                      </a>
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "VREB" ? (
                    <>
                      <b>VREB: </b>
                      <a href="mailto:vrebmbsignatures@exprealty.net">
                        vrebmbsignatures@exprealty.net
                      </a>
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel9"}
              onChange={handleAccordionChange("panel9")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel9-content"
                id="panel9-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  New Listing Procedures / Board Specific Emails
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <ThemeProvider theme={theme}>
                  <FormControl
                    sx={{ ml: 1, mt: 1, mb: 2, minWidth: 325, maxWidth: 110 }}
                  >
                    <InputLabel size="small" className="select-default-label">
                      Select Your Real Estate Board
                    </InputLabel>
                    <Select
                      value={Board}
                      name="Select Your Real Estate Board"
                      label="Select Your Real Estate Board"
                      onChange={handleBoardChange}
                      size="small"
                      sx={{ borderRadius: 20 }}
                      defaultValue="Select Your Real Estate Board"
                    >
                      <MenuItem key={Math.random()} value="AIR">
                        AIR
                      </MenuItem>
                      <MenuItem key={Math.random()} value="BCNREB">
                        BCNREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="CADREB">
                        CADREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="FVREB">
                        FVREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="GVR">
                        GVR (Previously REBGV)
                      </MenuItem>
                      <MenuItem key={Math.random()} value="PRSCREB">
                        PRSCREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="VIREB">
                        VIREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="VREB">
                        VREB
                      </MenuItem>
                    </Select>
                  </FormControl>
                </ThemeProvider>
                <p>
                  {Board !== "" ? (
                    <>
                      <ol>
                        <li>
                          Prepare all listing documents as per the Transaction
                          Checklists
                        </li>
                        <li>
                          Listing Contract must be signed by clients and agent
                          first
                        </li>
                        <li>
                          Send documents to your Managing Broker for electronic
                          signature
                        </li>
                        {Board === "BCNREB" ? (
                          <>
                            <li>
                              Agent Load your listing onto the MLS system &
                              email copies of your signed documents to your
                              Board MLS Dept
                            </li>
                            <li>
                              Once your listing is activated, upload any
                              required/supporting documents to the MLS System
                            </li>
                          </>
                        ) : (
                          ""
                        )}
                        {Board === "CADREB" || Board === "FVREB" ? (
                          <>
                            <li>Agent Load your listing onto the MLS system</li>
                            <li>
                              Email copies of your signed documents & the MLS
                              Activation Form to your Board MLS Dept
                            </li>
                            <li>
                              Once your listing is activated, upload any
                              required/supporting documents to the MLS System
                            </li>
                          </>
                        ) : (
                          ""
                        )}
                        {Board === "GVR" ||
                        Board === "VIREB" ||
                        Board === "VREB" ||
                        Board === "PRSCREB" ? (
                          <>
                            <li>Agent Load your listing onto the MLS system</li>
                            <li>
                              Once your listing is activated, upload any
                              required/supporting documents to the MLS System
                            </li>
                          </>
                        ) : (
                          ""
                        )}

                        {Board !== "AIR" ? (
                          <li>Upload all docs to SkySlope</li>
                        ) : (
                          ""
                        )}

                        {Board === "AIR" ? (
                          <>
                            <li>Agent Load your listing onto the MLS system</li>
                            <li>
                              Once your file is uploaded to Skyslope the Listing
                              Analyst will review the MLC. If approved, we will
                              activate your listing immediately <br />
                              <br />
                              **You no longer need to email our team to notify
                              us about activations UNLESS you require a delayed
                              activation. To request a delayed activation please
                              email{" "}
                              <a href="mailto:bclistings@exprealty.net">
                                bclistings@exprealty.net
                              </a>
                              , and write a note on the checklist beside the
                              MLC, “Please hold Activation until further
                              notice.”
                            </li>
                          </>
                        ) : (
                          ""
                        )}
                      </ol>
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "FVREB" ? (
                    <>
                      <b>FVREB:</b>{" "}
                      <a href="mailto:mlslistings@fvreb.bc.ca">
                        mlslistings@fvreb.bc.ca
                      </a>{" "}
                      <br />{" "}
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "CADREB" ? (
                    <>
                      <b>CADREB:</b>{" "}
                      <a href="mailto:cadrebmls@cadreb.com">
                        cadrebmls@cadreb.com
                      </a>{" "}
                      <br />{" "}
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "GVR" ? (
                    <>
                      <b>GVR (Previously REBGV): </b>
                      New Listings & Inquiries (
                      <a href="mailto:mls@gvrealtors.ca">mls@gvrealtors.ca</a>)
                      / Listing Amendments:{" "}
                      <a href="mailto:amendments@gvrealtors.ca">
                        amendments@gvrealtors.ca
                      </a>
                      <br />{" "}
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "VREB" ? (
                    <>
                      <b>VREB:</b>{" "}
                      <a href="mailto:mlsinput@vreb.org">mlsinput@vreb.org</a>
                      <br />{" "}
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "VIREB" ? (
                    <>
                      <b>VIREB:</b>{" "}
                      <a href="mailto:listings@vireb.com">listings@vireb.com</a>{" "}
                      <br />{" "}
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "BCNREB" ? (
                    <>
                      <b>BCNREB: </b>
                      <a href="mailto:listings@bcnreb.bc.ca">
                        listings@bcnreb.bc.ca
                      </a>{" "}
                      <br />{" "}
                    </>
                  ) : (
                    ""
                  )}
                  {Board === "AIR" ? (
                    <>
                      For Data Input Changes, or trouble with listings showing
                      on the site contact AIR directly:{" "}
                      <a href="mailto:listings@interiorrealtors.com">
                        listings@interiorrealtors.com
                      </a>{" "}
                    </>
                  ) : (
                    ""
                  )}
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel3"}
              onChange={handleAccordionChange("panel3")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel3-content"
                id="panel3-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Reporting a Firm Sale to MLS
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <ThemeProvider theme={theme}>
                  <FormControl
                    sx={{ ml: 1, mt: 1, mb: 2, minWidth: 325, maxWidth: 110 }}
                  >
                    <InputLabel size="small" className="select-default-label">
                      Select Your Real Estate Board
                    </InputLabel>
                    <Select
                      value={Board}
                      name="Select Your Real Estate Board"
                      label="Select Your Real Estate Board"
                      onChange={handleBoardChange}
                      size="small"
                      sx={{ borderRadius: 20 }}
                      defaultValue="Select Your Real Estate Board"
                    >
                      <MenuItem key={Math.random()} value="AIR">
                        AIR
                      </MenuItem>
                      <MenuItem key={Math.random()} value="BCNREB">
                        BCNREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="CADREB">
                        CADREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="FVREB">
                        FVREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="GVR">
                        GVR (Previously REBGV)
                      </MenuItem>
                      <MenuItem key={Math.random()} value="PRSCREB">
                        PRSCREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="VIREB">
                        VIREB
                      </MenuItem>
                      <MenuItem key={Math.random()} value="VREB">
                        VREB
                      </MenuItem>
                    </Select>
                  </FormControl>
                </ThemeProvider>
                {Board !== "" ? (
                  <>
                    <p>
                      <ol>
                        <li>
                          Complete the{" "}
                          <a
                            href="https://exprealty.formstack.com/forms/sales_report"
                            target="_blank"
                            rel="noreferrer"
                          >
                            eXp Sales Report Form{" "}
                          </a>
                          {Board === "AIR" ? (
                            <>
                              or use the{" "}
                              <a
                                href="https://www.expagentcentre.ca/commission-calculator"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Commission Calculator
                              </a>{" "}
                            </>
                          ) : (
                            ""
                          )}
                        </li>
                        <li>
                          Once completed, upload a copy to your SkySlope
                          Checklist
                        </li>
                        {Board !== "AIR" ? (
                          <>
                            <li>
                              Email a copy of your Sales Report Form to your
                              Board MLS Dept
                            </li>
                          </>
                        ) : (
                          ""
                        )}
                        {Board === "AIR" ? (
                          <>
                            <li>
                              Notify{" "}
                              <a href="mailto:bclistings@exprealty.net">
                                bclistings@exprealty.net
                              </a>{" "}
                              that your Sales Report (SR) is ready to process
                            </li>
                          </>
                        ) : (
                          ""
                        )}
                      </ol>

                      <br />
                    </p>
                    <p></p>

                    <p>
                      <strong>
                        To use the Standard Sales Report form in Webforms:
                      </strong>
                      <ol>
                        <li>Fill out the form</li>
                        <li>Have a Managing Broker sign (if applicable)</li>
                        <li>Upload a copy to SkySlope</li>
                        <li>
                          Email it to your MLS Department along with: CPS, SR,
                          and any date/price change addendums
                        </li>
                      </ol>
                    </p>
                    <br />

                    <p>
                      {Board !== "AIR" ? (
                        <>
                          <strong>MLS Department contacts:</strong>
                        </>
                      ) : (
                        ""
                      )}
                      <ol>
                        {Board === "FVREB" ? (
                          <li>
                            FVREB:{" "}
                            <a href="mailto:sales@fvreb.bc.ca">
                              sales@fvreb.bc.ca
                            </a>
                          </li>
                        ) : (
                          ""
                        )}

                        {Board === "CADREB" ? (
                          <li>
                            CADREB:{" "}
                            <a href="mailto:sales@cadreb.com">
                              sales@cadreb.com
                            </a>
                          </li>
                        ) : (
                          ""
                        )}

                        {Board === "GVR" ? (
                          <li>
                            GVR (formerly REBGV):{" "}
                            <a href="mailto:sales@gvrealtors.ca">
                              sales@gvrealtors.ca
                            </a>
                          </li>
                        ) : (
                          ""
                        )}

                        {Board === "BCNREB" ? (
                          <li>
                            BCNREB:{" "}
                            <a href="mailto:sales@bcnreb.bc.ca">
                              sales@bcnreb.bc.ca
                            </a>
                          </li>
                        ) : (
                          ""
                        )}

                        {Board === "VIREB" || Board === "VREB" ? (
                          <li>
                            VIREB &amp; VREB:
                            <ol>
                              <li>Agents report the sale in Matrix directly</li>
                              <li>
                                If not reporting in Matrix, obtain the Board
                                Sales Report form in Webforms
                              </li>
                              <li>
                                If reporting in Matrix, attach the full-detail
                                pending sale MLS sheet to the SkySlope checklist
                                instead of the Sales Report
                              </li>
                            </ol>
                          </li>
                        ) : (
                          ""
                        )}
                      </ol>
                    </p>
                  </>
                ) : (
                  ""
                )}
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel5"}
              onChange={handleAccordionChange("panel5")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel5-content"
                id="panel5-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Collapsed Sales & Listing Cancellations
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <div className="mb-card">
                  <h2>Listing Cancellations</h2>
                  <p>
                    <ol>
                      <li>
                        If the cancellation is amended to an unconditional
                        release, have all parties, including the broker, initial
                        the crossed-out section
                      </li>
                      <li>
                        Send to your Managing Broker for electronic signature
                        (Same email as for listing activations)
                      </li>
                      <li>
                        Once the Broker has signed, upload the form to SkySlope
                      </li>
                    </ol>
                  </p>
                  <p className="pt-3">
                    All documents are processed by admin during regular office
                    hours: Monday to Friday: 9am - 5pm
                  </p>
                </div>
                <br />
                <div>
                  <h2>Collapsed Sales</h2>
                  <p>
                    <strong>
                      If subjects are not removed and funds have NOT been
                      deposited:
                    </strong>
                    <ol>
                      <li>Click the Cancel Transaction button in Skyslope</li>
                      <li>Upload a Collapse of Sale form to the Checklist</li>
                      <li>Complete any remaining relevant checklist items</li>
                    </ol>{" "}
                  </p>
                  <br />
                  <p>
                    <strong>
                      If subjects are not removed and funds have HAVE been
                      deposited:
                    </strong>

                    <ol>
                      <li>Click the Cancel Transaction button in Skyslope</li>
                      <li>Upload a Collapse of Sale with Deposit form</li>
                      <li>
                        Upload a copy of the clients bank details / VOID Cheque
                        so eXp can return the deposit
                      </li>
                      <li>
                        Ensure the FINTRAC Receipt of Funds form has been
                        submitted via Fintracker, if on the Buyers side
                      </li>
                      <li>
                        Send an email to:{" "}
                        <a href="mailto:BCtransactions@exprealty.net">
                          BCtransactions@exprealty.net
                        </a>{" "}
                        so we can promptly process and return the deposit
                      </li>
                    </ol>
                  </p>
                  <br />
                  <p>
                    <strong>
                      If the deal has collapsed AFTER condtions have been
                      removed & sale has already been reported on MLS:
                    </strong>

                    <ol>
                      <li>
                        Fill out the General Release and Authorization form from
                        Webforms - this will determine who the deposit will go
                        to and all parties must sign
                      </li>
                      <li>
                        Complete the MLS Collapsed Sales Report in Webforms,
                        email it to your Managing Broker for e-signature, then
                        email the signed copy to your Real Estate Board and
                        upload a copy to SkySlope
                      </li>
                      <li>Click the Cancel Transaction button in Skyslope</li>
                      <li>
                        Send an email to:{" "}
                        <a href="mailto:BCtransactions@exprealty.net">
                          BCtransactions@exprealty.net
                        </a>{" "}
                        so we can promptly process and return the deposit
                      </li>
                      <li>
                        Notify your Managing Broker immediately of any potential
                        conflicts—for example, a party refusing to sign the
                        release form or disputes over fund disbursement
                      </li>
                    </ol>
                  </p>
                  <p className="pt-3">
                    All documents are processed by admin during regular office
                    hours: Monday to Friday: 9am - 5pm
                  </p>
                </div>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel4"}
              onChange={handleAccordionChange("panel4")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel4-content"
                id="panel4-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Lease Closing Procedure
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <p>
                  Since lawyers are typically not involved with lease closings,
                  eXp will need to be informed when the lease closes. <br />
                  <br />
                  Please email{" "}
                  <a href="mailto:BCpayouts@exprealty.net">
                    BCpayouts@exprealty.net
                  </a>{" "}
                  and{" "}
                  <a href="mailto:BCtransactions@exprealty.net">
                    BCtransactions@exprealty.net
                  </a>{" "}
                  once the tenants have taken possession. This will trigger the
                  closing process so that commissions/excess funds can be
                  disbursed.
                  <br />
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel14"}
              onChange={handleAccordionChange("panel14")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel4-content"
                id="panel4-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Buyer Agency & Disclosure Emails
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <p>
                  Please send your Buyer Agency or Disclosure documents to the
                  following email addresses:
                  <br /> <br />
                  Buyer Agency:{" "}
                  <a href="mailto:bc.buyeragency@exprealty.net">
                    bc.buyeragency@exprealty.net
                  </a>{" "}
                  <br />
                  <br />
                  Disclosures:{" "}
                  <a href="mailto:bcfsa.disclosure@exprealty.com">
                    bcfsa.disclosure@exprealty.com
                  </a>{" "}
                  <br />
                  <br />
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel2"}
              onChange={handleAccordionChange("panel2")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel2-content"
                id="panel2-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Additional eXp Forms (Commission/Referral...etc.)
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <p>
                  <a
                    href="https://drive.google.com/drive/folders/1NlFHAJ8wdgCPshm-CPKijPmxtAjkfJmU"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Commission Agreement Form
                  </a>
                  <br />
                  <br />
                  <a
                    href="https://drive.google.com/drive/folders/1NlFHAJ8wdgCPshm-CPKijPmxtAjkfJmU"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Disclosure of Referral Payment To Be Received
                  </a>
                  <br />
                  <br />
                  <a
                    href="https://drive.google.com/drive/folders/1NlFHAJ8wdgCPshm-CPKijPmxtAjkfJmU"
                    target="_blank"
                    rel="noreferrer"
                  >
                    eXp Agent Referral Agreement
                  </a>
                  <br />
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel6"}
              onChange={handleAccordionChange("panel6")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel6-content"
                id="panel6-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  eXp SkySlope - Submitting your Documents to the Brokerage
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <p>
                  Deals should be submitted to the Brokerage via SkySlope within
                  48 hours of having an accepted agreement. If your board
                  provides access to SkySlope, as part of your board fees, this
                  is a different SkySlope than eXp's. Login to{" "}
                  <a
                    href="https://app.skyslope.com/LoginIntegrated.aspx"
                    target="_blank"
                    rel="noreferrer"
                  >
                    SkySlope
                  </a>{" "}
                  using your @exprealty.com email address.
                  <br />
                  <br />
                  Here are some training videos (2-3 mins) on how to create your
                  listing & transaction files:
                  <br />
                  <br />
                  <a
                    href="https://support.skyslope.com/support/solutions/articles/156000366460-create-a-transaction-canada-"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Create A Buyer/Tenant Transaction (3 mins)
                  </a>
                  <br /> <br />
                  <a
                    href="https://support.skyslope.com/support/solutions/articles/156000366461-create-a-listing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Create A Listing Transaction (2.5 mins)
                  </a>
                  <br />
                  *Some features like transferring over docs automatically may
                  not be available.
                  <br /> <br />
                  <a
                    href="https://support.skyslope.com/support/solutions/articles/156000366436-convert-a-listing-to-a-transaction"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Convert a Listing to a Transaction: Accepted Offer on Your
                    Listing (3 min article)
                  </a>
                  <br />
                  <br />
                  <a
                    href="https://drive.google.com/drive/folders/1NlFHAJ8wdgCPshm-CPKijPmxtAjkfJmU"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Create a Referral Transaction in SkySlope (3 min article)
                  </a>
                  <br />
                  <br />
                  <a
                    href="https://support.skyslope.com/support/solutions/articles/156000366393-using-split-assign"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Split & Assign Documents to the Checklist (2 mins)
                  </a>
                  <br />
                  <br />
                  <a
                    href="https://support.skyslope.com/support/solutions/articles/156000366392-attaching-a-document-to-the-checklist"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Attaching a Document to the Checklist (1 min)
                  </a>
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordion === "panel7"}
              onChange={handleAccordionChange("panel7")}
              sx={{
                mb: 1,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                },
                "& .MuiAccordionDetails-root": {
                  padding: "24px 15px 15px 15px",
                },
                "&.Mui-expanded": {
                  margin: "8px 0",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                aria-controls="panel7-content"
                id="panel7-header"
                sx={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e0e0e0",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  minHeight: "48px",
                  height: "48px",
                  "@media (max-width: 768px)": {
                    minHeight: "60px",
                    height: "60px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "8px 0",
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  },
                  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(180deg)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                  },
                  "&.Mui-expanded": {
                    backgroundColor: "rgba(12, 15, 36, 0.1)",
                    minHeight: "48px",
                    height: "48px",
                    "@media (max-width: 768px)": {
                      minHeight: "60px",
                      height: "60px",
                    },
                  },
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0c0f24",
                    fontSize: "16px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  FINTRAC Documents & Procedures
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-content">
                <div>
                  <ol>
                    <li>
                      Please complete all required FINTRAC documents for your
                      transaction in the Fintracker app.
                    </li>

                    <li>
                      Once you have completed your FINTRAC document in
                      Fintracker, copy & paste the FIN# in the comment box of
                      your related SkySlope checklist item. Do not upload PDF
                      files to SkySlope.
                    </li>
                    <li>
                      Mutually Released deals will need FINTRACs completed
                      before funds can be released.
                    </li>
                  </ol>
                  <br />
                  <h2>Fintracker (PC/Mobile)</h2>

                  <ol>
                    <li>
                      All FINTRAC documents are to be completed in the
                      Fintracker app (Mobile) or{" "}
                      <a
                        href="https://www.fintracker.ca"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Fintracker.ca
                      </a>{" "}
                      (PC) .
                    </li>
                    <li>
                      {" "}
                      Create an account at{" "}
                      <a
                        href="https://www.fintracker.ca"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Fintracker.ca
                      </a>{" "}
                      using your @exprealty.com email address.
                    </li>
                    <li>
                      Visit{" "}
                      <a
                        href="https://www.fintracker.ca/tutorials.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        fintracker.ca/tutorials
                      </a>{" "}
                      for tutorials on how to use Fintracker.
                    </li>
                  </ol>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
